<nz-modal
  [(nzVisible)]="isVisible"
  nzCentered
  [nzFooter]="null"
  nzClosable="true"
  (nzOnCancel)="handleContinue()"
>
  <ng-container *nzModalContent>
    <div class="text-center flex flex-col p-4">
      <div class="flex flex-col items-center">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
          alt="warning"
          width="100px"
        />
        <div class="title mt-3">Document Information</div>
      </div>
      <span class="mt-3 text-grey">
        This menu is only required if you use Shipping Delivery API,  Payment API. and QRISLY. If you are using Shipping Cost Check API, you don’t need to fill in any documents.
      </span>
      <div class="d-flex justify-content-betweeen mt-3 gap-2">
        <button
          class="btn btn-outline-primary text-primary col-6"
          (click)="handleContinue()"
        >
          Skip for Now
        </button>
        <button
          class="btn btn-primary text-white col-6"
          (click)="handleContinue()"
        >
          Continue
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
